
import React from 'react'
import Layout from '../../components/layout'

import QuoteCard from '../../components/QuoteCard'

import avatar_jl from '../../assets/employees/johan-profil.jpg'
import avatar_gl from '../../assets/employees/gustav-profil.jpg'
import avatar_rn from '../../assets/employees/robert-profil.jpg'

const quotes = [
  { name: "Johan Lahti", avatar: avatar_jl, title: "Sr. Consultant & CEO", quote: "I en modern arkitektur är nätverket designat för att automatiseras och automationslösningen är skräddarsydd för nätverket." },
  { name: "Gustav Larsson", avatar: avatar_gl, title: "Sr. Consultant", quote: "Våra välutvecklade processer gör det möjligt för oss att skapa skräddarsydda team som levererar verkligt värde. Genom noggranna reviewprocesser och samarbete ser vi till att varje leverans håller högsta kvalitet!" },
  { name: "Robert Nilsson", avatar: avatar_rn, title: "Sr. Consultant & Manager", quote: "En stark kultur bygger på ödmjukhet, tillit och yrkesstolthet. Genom att kombinera professionalism, trygghet och ständig utveckling skapar vi en miljö där teamet växer tillsammans – både tekniskt och som individer." }
]


export default function AboutPage() {
  return (
    <Layout>
      <div id="about" className="section flex flex-col gap-10 sm:gap-16">
        <div className="flex flex-col gap-6 sm:gap-10">
          <div className="flex flex-col gap-4">
            <p className="eyebrow">Om oss</p>
            <p className="max-w-4xl text-2xl sm:text-4xl font-semibold leading-tight tracking-tight">
              2020 grundades <span className="text-sky-500">AceBit</span> med en vision om att ett modernt, automatiserat nätverk kräver kunskap inom både nätverks- och systemutveckling.
            </p>
          </div>
          <div className="lead grid gap-4 md:grid-cols-2 md:gap-12">
            <p>
              Vår syn på nätverksdesign utgår från att dessa områden måste harmoniseras för att skapa riktigt bra lösningar som skalar och bringar verklig nytta till verksamheten!
            </p>
            <p>
              Idag har vi byggt ett erfaret team på vår <span className="text-sky-500">vision</span> - som kombinerar expertis inom design, implementation
              och drift av det vi kallar moderna nätverk. Målet är inte bara följa de senaste trenderna, utan även att våga utforska och utveckla framtidens nätverkslösningar – the <span className="text-sky-500">AceBit</span> way.
            </p>
          </div>
        </div>

        {/* Swipe-rad på mobil, tre kolumner från md */}
        <div className="scroll-row md:mx-0 md:grid md:grid-cols-3 md:gap-6 md:overflow-visible md:px-0 md:pb-0">
          {quotes.map((item) => (
            <div key={item.name} className="w-[85%] shrink-0 snap-center md:w-auto">
              <QuoteCard
                name={item.name}
                title={item.title}
                quote={item.quote}
                avatar={item.avatar}
              />
            </div>
          ))}
        </div>

        {/* Tar bort kundlogos tills vi hunnit kolla att vi får ha dom */}

        {/* <div>
          <hr className="my-12 h-0.5 border-t-0 bg-neutral-100 dark:bg-white/10" />
          <p className="text-lg text-gray-700">Några av våra kunder:</p>
          <CustomerLogos />
        </div> */}
      </div>
    </Layout>
  )
}
